export default "__VITE_ASSET__$WftYnP6__"